export default __webpack_public_path__ + "static/media/rightArrowButton.ecb0d85c.svg";